export default "<p *ngIf=\"tooltip\" class=\"new-layout qrmenu-tooltip\"\n   [ngClass]=\"tooltip.classes\" [innerHTML]=\"tooltip.html\">\n</p>\n<br>\n";